import type { NotificationSound } from '@auw/api-client';

// Synthesized locally; no files, CDN, browser notification permission or network.
let context: AudioContext | undefined;

/** Serialize the shared playback claim across tabs polling the same inbox. */
export async function playCompletionSound(account: string, notificationId: string, sound: NotificationSound): Promise<void> {
  const key = 'sola-notification-sound:' + account;
  const play = () => {
    try {
      if (localStorage.getItem(key) === notificationId) return;
      localStorage.setItem(key, notificationId);
    } catch { /* Sound is optional when browser storage is disabled. */ }
    playNotificationSound(sound);
  };
  if (navigator.locks?.request) {
    await navigator.locks.request(key, play);
  } else {
    play();
  }
}

export function primeNotificationAudio(): void {
  try {
    context ??= new AudioContext();
    if (context.state === 'suspended') void context.resume().catch(() => {});
  } catch { /* Browsers without audio still show the inbox. */ }
}
export function playNotificationSound(sound: NotificationSound): void {
  primeNotificationAudio();
  if (!context || context.state !== 'running') return;
  const notes: Record<NotificationSound, number[]> = { chime: [659, 880], bell: [784, 1047, 784], soft: [523, 659] };
  const start = context.currentTime;
  notes[sound].forEach((frequency, index) => {
    const oscillator = context!.createOscillator(), gain = context!.createGain();
    const at = start + index * 0.16;
    oscillator.type = 'sine';
    oscillator.frequency.value = frequency;
    gain.gain.setValueAtTime(0, at);
    gain.gain.linearRampToValueAtTime(sound === 'soft' ? .035 : .06, at + .012);
    gain.gain.exponentialRampToValueAtTime(.0001, at + .38);
    oscillator.connect(gain); gain.connect(context!.destination);
    oscillator.start(at); oscillator.stop(at + .4);
    oscillator.onended = () => { oscillator.disconnect(); gain.disconnect(); };
  });
}
